// OpenStreetMap の登山道データを Overpass API から取得し GeoJSON に変換
//
// 取得対象:
//   - highway=path / footway / track (歩道・小径・林道)
//   - sac_scale=* (アルプスクラブの登山道難易度タグ)
//
// 利用上の注意:
//   - Overpass API はオンライン専用(オフライン不可)
//   - レート制限: 共有サーバーでは公平利用が原則(数秒に1回程度に抑える)
//   - 大きい bbox はタイムアウトする(8 km 四方程度が安全)

const OVERPASS_URL = 'https://overpass-api.de/api/interpreter';
const TIMEOUT_SEC = 25;
const MAX_BBOX_AREA = 0.5; // 度二乗 (約 50km 四方)

export async function fetchHikingPaths(bbox, signal) {
  if (!bbox) return { type: 'FeatureCollection', features: [] };
  // bbox: { south, west, north, east }
  const area = (bbox.north - bbox.south) * (bbox.east - bbox.west);
  if (area > MAX_BBOX_AREA) {
    return { type: 'FeatureCollection', features: [], error: 'BBOX が広すぎます。ズームを上げてください' };
  }

  const query = `[out:json][timeout:${TIMEOUT_SEC}];
(
  way["highway"~"^(path|footway|track)$"](${bbox.south},${bbox.west},${bbox.north},${bbox.east});
  way["sac_scale"](${bbox.south},${bbox.west},${bbox.north},${bbox.east});
);
out geom;`;

  try {
    const res = await fetch(OVERPASS_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'data=' + encodeURIComponent(query),
      signal,
    });
    if (!res.ok) {
      console.warn('Overpass error', res.status);
      return { type: 'FeatureCollection', features: [], error: 'Overpass API エラー' };
    }
    const data = await res.json();
    return overpassToGeoJSON(data);
  } catch (e) {
    if (e.name === 'AbortError') return { type: 'FeatureCollection', features: [], aborted: true };
    console.warn('Overpass fetch failed', e);
    return { type: 'FeatureCollection', features: [], error: e.message };
  }
}

function overpassToGeoJSON(data) {
  const elements = data.elements || [];
  const features = elements
    .filter((el) => el.type === 'way' && Array.isArray(el.geometry) && el.geometry.length >= 2)
    .map((el) => ({
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: el.geometry.map((n) => [n.lon, n.lat]),
      },
      properties: {
        highway: el.tags?.highway || '',
        sac_scale: el.tags?.sac_scale || '',
        name: el.tags?.name || '',
      },
    }));
  return { type: 'FeatureCollection', features };
}

// localStorage キー管理
export function isOsmHikingEnabled() {
  return localStorage.getItem('sentier.showOsmHiking') === '1';
}

export function setOsmHikingEnabled(on) {
  if (on) localStorage.setItem('sentier.showOsmHiking', '1');
  else localStorage.removeItem('sentier.showOsmHiking');
}
